import React from "react";
import { useNavigate } from "react-router-dom";
import plusIcon from "../../assets/icon/general/piu.png"; // assicurati che non dia errori col carattere speciale

const CreateActivityButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/new-activity");
  };

  return (
    <button
      onClick={handleClick}
      className="text-white font-medium border border-secondary  rounded-full hover:bg-primary/90 transition"
    >
      <div className="flex justify-between space ">
      <img src={plusIcon} alt="plus" className="w-10 h-10 pb-1 rounded-full border border-secondary mr-2  " />
      <span className="mr-4 mt-2">Crea Attività</span>
      </div>
      
    </button>
  );
};

export default CreateActivityButton;
